<template>
  <div class="time-container">
    <Header backgroundColor="#cfcfcf !important" borderBottom="1px solid #cfcfcf"></Header>
    <div class="license-number">
      <div class="dot dot-l"></div>
      {{resultList.licenseplate}}
      <div class="dot dot-r"></div>
    </div>
    <div class="main-container">
      <b-row class="time-info">
        <b-col cols="5">
          <p class="enter-text">{{$t('m.time.inTime')}}</p>
          <p class="enter-time">{{actualInTime}}</p>
        </b-col>
        <b-col cols="2">
          <div center class="split"></div>
        </b-col>
        <b-col cols="5">
          <p class="enter-text">{{$t('m.time.duration')}}</p>
          <p class="enter-time">{{appointTime}}</p>
        </b-col>
      </b-row>
      <div class="countdown">
        <img class="countdown-bg" :src="timeBG" width="200">
        <div class="countdown-circle" :style="{backgroundColor: circleColor}">
          <p>
            {{circleTip}}
            <!-- <img
              class="countdown-tip"
              src="../../assets/img/gantanhao.png"
              width="15"
              v-show="resultList.isTimeout==2"
            >-->
          </p>
          <p v-if="resultList.isTimeout==2">{{availableTime}}</p>
          <!--剩余时间 -->
          <p v-if="resultList.isTimeout==1">
            {{timeOutTime}}
            <span id="chaoshi">{{$t('m.time.overtimeFee')}}:{{resultList.timeoutPrice}}{{$t('m.time.CNY')}}</span>
          </p>
          <!--超时时间 -->
        </div>
      </div>
      <div v-if="resultList.chargeEquipment === 2" class="button">
        <b-button @click="refresh()">{{$t('m.time.refreshTime')}}</b-button>
      </div>
      <div v-if="resultList.selfService === 1 && resultList.chargeEquipment === 1" class="button-charge">
        <b-button @click="refresh()">{{$t('m.time.refreshTime')}}</b-button>
        <b-button @click="goCharge()">{{ chargeBtnTitle }}</b-button>
      </div>
      <img src="../../assets/img/time-car@2x.png" width="80%">
      <p v-if="resultList.disperserTimeId == null"
         class="station-addr"
         style="border:1px solid #0066B1;border-radius:5px;"
      >{{$t('m.time.tips')}}</p>
      <p v-else class="station-addr"
         style="border:1px solid #0066B1;border-radius:5px;">温馨提示: 请在停车结束后到达{{resultList.voucherAddress}}领取出场凭证</p>
      <footer>
        <b-btn variant="primary" v-if="resultList.entranceWay == 1"
               v-b-modal.leave-disperser-modal
               style="width:100%;line-height:30px;"
        >获取离场凭证
        </b-btn>
      </footer>
    </div>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
    <b-modal
        hide-header
        id="leave-disperser-modal"
        class="cancelOrders"
        cancel-title="取消"
        ok-title="确认"
        @ok="handleManualLeave()"
    >
      <p class="my-4"
         style="margin-bottom:5px !important;padding:0 25px;font-size:15px;"
      >获取凭证后请在15分钟内驶离停车场</p>
    </b-modal>
  </div>
</template>
<script>
  import {parkingTime} from "../../api/time.js";
  import DateUtil from "../../utils/DateUtil";
  import {orderStatus, manualLeave} from "../../api/order.js";
  import {dateAdd, formatDate, hourtoMinute} from "@/utils/DateFomatUtil";
  // import { userOrderStatus } from "../api/order.js";
  export default {
    name: "Time",
    data() {
      return {
        circleColor: "#0066B1",
        circleTip: "",
        orderId: "", //订单Id
        resultList: {}, //数据
        actualInTime: "", //转换出来的进场时间
        appointTime: "", //转换成预约时间
        timeOutTime: "", //超时时间
        availableTime: "", //剩余时长
        message: "", //提示信息
        tipShow: "0", //是否提示
        tipType: "", //提示类型
        ostatus: null,
        chargeBtnTitle: ''
      };
    },
    methods: {
      //加载方法
      loadParkingTime: function () {
        parkingTime({orderId: this.orderId}).then(
            response => {
              if (response.data.status == 200) {
                this.resultList = response.data.result;

                if(!this.resultList.chargeInfo){
                  this.chargeBtnTitle = '去充电'
                } else if (this.resultList.chargeInfo && this.resultList.chargeInfo.chargeStatus === 2) {
                  this.chargeBtnTitle = '充电信息'
                } else if (this.resultList.chargeInfo) {
                  this.chargeBtnTitle = '充电信息'
                }

                if (this.resultList.status == 6 || this.resultList.status == 5) {

                  if (this.resultList.status == 5) {
                    if (this.resultList.overTimeFee == 1||this.resultList.overTimeFee===3) {
                        this.$router.push("/overtimeOrder/" + this.orderId);
                        return
                    }
                  }

                  // if(this.resultList.overTimeFee===3){

                  //     this.$router.push("/overtimeOrder/" + this.orderId);
                  //     return
                  // }

                  this.tipShow = "1" + Math.random() * 1000;
                  this.tipType = "success";
                  this.message = this.$t('m.time.orderAccomplish');

                  if (response.data.result.entranceWay == 1) {
                    setTimeout(_ => {
                      this.$router.push("/gotoLeaveVoucher/" + this.orderId);
                    }, 1100);

                  } else {
                    setTimeout(_ => {
                      this.$router.push("/");
                    }, 1100);
                  }
                }
                //截取进场时间
                this.actualInTime = this.resultList.actualInTime.split(" ")[1];
                //转换预约时间
                this.appointTime = hourtoMinute(this.resultList.appointTime, this.$t('m.dataTime.hours'), this.$t('m.dataTime.minute'));
                //已超时和剩余时间字段转时间
                if (this.resultList.isTimeout == 2) {
                  this.circleTip = this.$t('m.time.surplusTime');
                  var availableTime = this.resultList.availableTime;
                  var hour = Math.floor(availableTime / 60);
                  var datas = availableTime % 60;
                  if (hour < 10) {
                    hour = "0" + hour;
                  }
                  if (datas < 10) {
                    datas = "0" + datas;
                  }
                  this.availableTime = hour + ":" + datas;
                } else if (this.resultList.isTimeout == 1) {
                  this.circleTip = this.$t('m.time.timePeriod');
                  var timeOutTime = this.resultList.timeOutTime;
                  var hour = Math.floor(timeOutTime / 60);
                  var datas = timeOutTime % 60;
                  if (hour < 10) {
                    hour = "0" + hour;
                  }
                  if (datas < 10) {
                    datas = "0" + datas;
                  }
                  this.timeOutTime = hour + ":" + datas;
                }
              } else {
                if (this.ostatus != null) {
                  clearInterval(this.ostatus);
                }
                this.tipShow = "1" + Math.random() * 1000;
                this.message = response.data.message;
                this.tipType = "warning";
              }
            }
        );
      },
      //刷新时间
      refresh: function () {
        this.loadParkingTime(); //方法刷新
        this.tipShow = "1" + Math.random() * 1000000;
        this.message = this.$t('m.time.refreshSuccess');
        this.tipType = "success";
      },
      goCharge () {
        if(!this.resultList.chargeInfo){
          this.$router.push("/charge/" + this.orderId);
        } else if (this.resultList.chargeInfo && this.resultList.chargeInfo.chargeStatus === 2) {
          this.$router.push("/chargeInfo/" + this.orderId);
        } else {
          this.$router.push("/chargeDetail/" + this.orderId + '/' + this.resultList.chargeInfo.chargeSeq);
        }

      },
      //手动离场
      handleManualLeave() {
        manualLeave({id: this.orderId}).then(response => {
          if (response.data.status != 200) {
            this.tipShow = "1" + Math.random() * 1000;
            this.tipType = "warning";
            this.message = "离场失败";
          }
        })
      },
      //轮询订单状态
      orderStatus() {
        let this_s = this;
        this.ostatus = setInterval(function () {
          this_s.loadParkingTime();
        }, 5000);
      }
    },
    computed: {
      timeBG: function () {
        if (this.resultList.isTimeout == 2) {
          this.circleColor = "#0066B1";
          return require("../../assets/img/time-bg-blue.png");
        } else if (this.resultList.isTimeout == 1) {
          this.circleColor = "#D61C24";
          this.circleTip = this.$t('m.time.overtime');
          return require("../../assets/img/time-bg-red.png");
        }
      }
    },
    //加载事件
    created() {
      this.orderId = this.$route.params.orderId; //订单Id
      this.loadParkingTime();
      this.orderStatus();
    },
    destroyed() {
      if (this.ostatus != null) {
        clearInterval(this.ostatus);
      }
    }
  };
</script>

<style scoped>
  .time-container {
    /* background-color: #cfcfcf !important; */
    height: 100%;
  }
  .license-number {
    position: absolute;
    top: 5px;
    left: 0px;
    right: 0px;
    max-width: 130px;
    height: 37px;
    margin: 0 auto;
    border: 1px solid #999999;
    font-size: 18px;
    font-family: BMWTypeGlobalPro-Light;
    text-align: center;
    line-height: 36px;
    border-radius: 7px;
  }

  .license-number .dot {
    width: 4px;
    height: 4px;
    background-color: black;
    border-radius: 50%;
    position: absolute;
    top: 0px;
    bottom: 0px;
    margin: auto;
  }

  .license-number .dot-l {
    left: 5px;
  }

  .license-number .dot-r {
    right: 5px;
  }

  .time-info {
    padding: 1rem 1.5rem;
  }

  .time-info .split {
    width: 50%;
    height: 50px;
    border-right: 1px solid #999999;
  }

  .time-info p {
    margin-bottom: 3px;
  }

  .time-info .enter-text {
    font-size: 13px;
    font-weight: bold;
  }

  .time-info .enter-time {
    font-size: 23px;
    color: #0066B1;
    font-weight: bold;
  }

  .countdown {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    position: relative;
    margin-bottom: 20px;
  }

  .countdown .countdown-bg {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0px;
    top: 0px;
    bottom: 0px;
    margin: auto;
  }

  .countdown .countdown-circle {
    width: 90%;
    height: 90%;
    border-radius: 50%;
    border: 5px solid white;
    position: absolute;
    z-index: 1;
    color: white;
    left: 0;
    right: 0px;
    top: 0px;
    bottom: 0px;
    margin: auto;
  }

  .countdown .countdown-circle .countdown-tip {
    position: relative;
    top: -2px;
  }

  .countdown .countdown-circle p:first-child {
    font-size: 11px;
    margin-bottom: 0px !important;
    position: absolute;
    top: 41px;
    left: 0;
    right: 0;
    font-weight: bold;
  }

  .countdown .countdown-circle p:last-child {
    font-size: 38px;
    margin-bottom: 0px !important;
    position: absolute;
    top: 59px;
    left: 0;
    right: 0;
    font-weight: bold;
  }

  .main-container .button-charge {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 6px;
  }
  .main-container .button-charge button {
    background-color: #0066B1 !important;
    width: 160px;
    margin: 8% 0px;
    font-size: 14px;
  }
  .main-container .button button {
    background-color: #0066B1 !important;
    margin-bottom: 10px;
    width: 120px;
  }

  .station-addr {
    color: #0066B1;
    margin-top: 20px;
    font-size: 14px;
    /* position: absolute; */
    left: 0px;
    right: 0px;
    margin-bottom: 7px;
  }

  .station-addr span {
    padding: 2px;
    border: 1px solid;
    border-radius: 5px;
    border-right: none;
  }

  .station-le-info {
    /* position: absolute; */
    margin-bottom: 0px;
    font-size: 14px;
    bottom: 20px;
    left: 0px;
    right: 0px;
  }

  .station-le-info span {
    color: #0066B1;
  }

  #chaoshi {
    font-size: 12px;
    display: block;
    font-family: "宋体";
  }
</style>
